import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {AbstractDataModel} from './abstract-data.model';
import {ServiceAnswer} from './service-answer';

/**
 * Service skeleton. This service is able to manipulate local and session storages
 */
@Injectable()
export abstract class AbstractDataService<T> {

  /**
   * Default constructor
   * @param {HttpClient} http - Angular Http Client
   * @param url
   */
  protected constructor(protected http: HttpClient, protected url: string) {
  }

  public async filterData<S = T>(query: string): Promise<ServiceAnswer<AbstractDataModel<S>>> {
    const serviceAnswer: ServiceAnswer<AbstractDataModel<S>> = {isOk: null, isDataEqual: true};

    try {
      serviceAnswer.data = await this.http.get<AbstractDataModel<S>>(this.url + query).toPromise();
      serviceAnswer.isOk = true;
    } catch (error) {
      console.error(`Error when fetching entities from ${this.url + query}: ${JSON.stringify(error)}`);
      serviceAnswer.isOk = false;
      serviceAnswer.errorCode = error.status;
      serviceAnswer.errorMessage = error.message + '. Answer body: ' + JSON.stringify(error.error);
    }
    return serviceAnswer;
  }
}
